import React, { useEffect, useState, useRef } from "react";
import "./errorMessageComponent.css";
import { getLighterHexColor } from "../../utils/cssUtils.js";
import { BiSolidError } from "react-icons/bi";

const ErrorMessageComponent = (props) => {
  const divRef = useRef(null);
  const [bgColor, setBgColor] = useState("");

  useEffect(() => {
    // Only try to access the ref when the component is mounted and error message exists
    if (props.errorMessage && divRef.current) {
      const styles = getComputedStyle(divRef.current);
      const dangerColor = styles
        .getPropertyValue("--inside-danger-color")
        .trim();
      console.log("colorr", dangerColor);
      setBgColor(dangerColor);
    }
  }, [props.errorMessage]); // Add props.errorMessage as dependency

  if (!props.errorMessage) {
    return <div className="error-form-text-filler"></div>;
  }

  return (
    <div
      ref={divRef}
      className="error-message-div"
      style={{
        backgroundColor: bgColor ? getLighterHexColor(bgColor, 0.1) : undefined,
      }}
    >
      <BiSolidError class="error-message-icon" />
      <div class="error-message-text">
        <div class="error-message-title">{props.errorMessage}</div>
        {props.errorCode ? (
          <div class="error-message-code">
            {props.localizedText["code"] + ":"} <code>{props.errorCode}</code>
          </div>
        ) : null}
        {props.errorDetail ? (
          <div class="error-message-detail">{props.errorDetail}</div>
        ) : null}
      </div>
    </div>
  );
};

export default ErrorMessageComponent;
